import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Close as CloseIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  banner: {
    marginBottom: theme.spacing(2),
    backgroundColor: '#fff9c4', // Light yellow
    color: '#795548', // Brown text for better contrast
    '& .MuiAlert-icon': {
      color: '#f57c00', // Orange icon
    },
  },
}));

const NotificationBanner = ({ notification, onDismiss }) => {
  const classes = useStyles();

  if (!notification) {
    return null;
  }

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss(notification.userNotificationId);
    }
  };

  // Parse JSON data if it's a string
  let notificationData = {};
  try {
    notificationData = typeof notification.notificationData === 'string'
      ? JSON.parse(notification.notificationData)
      : notification.notificationData;
  } catch (e) {
    console.error('Failed to parse notification data:', e);
  }

  const getMessage = () => {
    if (notification.notificationType === 'CoverageAssigned') {
      const { assignedBy, fileCount, startDate, endDate, isUpdate } = notificationData;
      const action = isUpdate ? 'updated' : 'assigned';
      return `${assignedBy} has ${action} you coverage for ${fileCount} file${fileCount > 1 ? 's' : ''} from ${new Date(startDate).toLocaleDateString()} to ${new Date(endDate).toLocaleDateString()}.`;
    }
    return 'You have a new notification.';
  };

  return (
    <Alert
      severity="success"
      className={classes.banner}
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={handleDismiss}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      {getMessage()}
    </Alert>
  );
};

NotificationBanner.propTypes = {
  notification: PropTypes.shape({
    userNotificationId: PropTypes.number.isRequired,
    notificationType: PropTypes.string.isRequired,
    notificationData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  onDismiss: PropTypes.func.isRequired,
};

export default NotificationBanner;
